import { render, staticRenderFns } from "./ToggleWText.vue?vue&type=template&id=6a130d2a&scoped=true&"
import script from "./ToggleWText.vue?vue&type=script&lang=js&"
export * from "./ToggleWText.vue?vue&type=script&lang=js&"
import style0 from "./ToggleWText.vue?vue&type=style&index=0&id=6a130d2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a130d2a",
  null
  
)

export default component.exports